export * from './side-slider.component';
export * from './side-slider.module';
export * from './side-slider.service';
